import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface addClientFields {
    name?: string;
    account_no?: string;
    serial_no?: string;
    phone?: string;
    fax?: string;
    mobile?: string;
    email?: string;
    website?: string;
    country?: string;
    government?: string;
    city?: string;
    postal_code?: string;
    department_number?: string;
    address_1?: string;
    address_2?: string;
    address_3?: string;
    type?: 'Post Paid' | 'Cash';
    debt_ceiling?: number;
    tax_number?: string;
}

// Add client state
export interface addClientState {
    fields: addClientFields;
    editId: number;
    isLoading: boolean;
    isSuccess: boolean;
    isOpen: boolean;
}

const initialAddClientState: addClientState = {
    fields: {
        type: "Post Paid"
    },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Add client slice
export const addClientSlice = createSlice({
    name: 'add_client',
    initialState: initialAddClientState,
    reducers: {
        init: state => initialAddClientState,
        set: (state, { payload }: PayloadAction<addClientFields>) => {
            state.fields = { ...state.fields, ...payload }
        },
        setEditId: (state, { payload }: PayloadAction<number>) => {
            state.editId = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsSuccess: (state, { payload }: PayloadAction<boolean>) => {
            state.isSuccess = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        },
    }
})